<template>
  <confirmation-dialog
    visible
    :title="$t('label.cancel_reservation')"
    :confirm-title="confirmCancelButtonTitle"
    :cancel-title="$t('button.keep_reservation')"
    @confirm="shouldRefund ? emit('refund-reservation') : emit('cancel-reservation')"
    @close="emit('close')"
  >
    <p class="font-weight-regular text-body-2 pt-0 text--primary">
      {{ $t('message.confirm_cancel_booking') }}
    </p>
    <p
      v-if="reservation.paymentInfo"
      class="py-0 my-0"
    >
      <v-divider />
      <v-checkbox
        v-model="shouldRefund"
        :disabled="!isFinal"
        dense
        class="pt-2 py-0 font-weight-regular"
        hide-details
      >
        <template #label>
          <span class="font-weight-regular text--primary text-body-2">
            {{ $i18n.t('label.refund_x_amount', [reservation.paymentInfo]) }}
          </span>
        </template>
      </v-checkbox>
      <span
        v-if="isFinal"
        class="text-caption"
      >
        {{ i18n.t('message.reservation_became_final_on_date', [localized.mediumDateTimeText(finalDate)]) }}
      </span>
    </p>
  </confirmation-dialog>
</template>

<script lang="ts" setup>
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog.vue';
import Reservation from '@/model/Reservation';
import i18n from '@/plugins/i18n';
import { computed, PropType, ref } from 'vue';
import { useLocalized } from '../helpers/vue2-helpers';

const emit = defineEmits(['cancel-reservation', 'refund-reservation', 'close']);
const localized = useLocalized();
const props = defineProps({
  reservation: { type: Object as PropType<Reservation>, required: true },
});

const finalDate = computed(() => {
  if (props.reservation.dateFinal
   && props.reservation.dateCreated
   && (props.reservation.dateFinal < props.reservation.dateCreated)) {
    return props.reservation.dateCreated;
  }
  return props.reservation.dateFinal;
});

const isFinal = computed(() => props.reservation.dateFinal && new Date() > props.reservation.dateFinal);

const shouldRefund = ref(!isFinal.value && props.reservation.paymentInfo);

const confirmCancelButtonTitle = computed(
  () => (shouldRefund.value ? i18n.t('button.cancel_and_refund') : i18n.t('label.cancel_reservation')),
);

</script>
